import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AddressModel, StepIndicatorModel } from '@app/state/models/add-address.model';
import {
  selectAddAddress, selectConfirmationNumber,
  selectSendAccounts,
  selectStepIndicatorIndex,
} from '../../../state/selectors/add-address.selector';
import { Observable } from 'rxjs';
import { Account } from '@app/models/thirdparty-documents.model';
import { AemUtil } from '@app/utils/aem.util';
import { ThirdpartyDocumentsAemItem } from '@app/models/aem.model';
import {
  ACCOUNTS_AVAILABLE_FOR_SELECTION_TABLE, BACK_TO_DUPLICATE_STATEMENTS_BUTTON,
  DUPLICATE_STATEMENT_ADDRESS_LABEL,
  REVIEW_AND_SUBMIT_PAGE_CONTAINER, SELECT_ACCOUNT_TABLE_LABEL, SHOW_LESS_LABEL, SHOW_MORE_LABEL,
} from '@app/constants/aem.constant';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent implements OnInit {
  labels = {
    heading: '',
    confirmationNumberLabel: '',
    confirmationNumberHeading: '',
    thankYouMessage: '',
    symbol: '',
    name: '',
    fundAccount: '',
    duplicateStatementAddress: '',
    selectedAccounts: '',
    backToDuplicateStatements: '',
    showMore: '',
    showLess: '',
    selectAccountTableLabel: '',
  };
  @Input() thirdpartyDocumentsAemContent: ThirdpartyDocumentsAemItem;
  currentStepIndicatorIndex$: Observable<number>;
  address$: Observable<AddressModel>;
  accounts;
  confirmPageDetails;
  private allAccounts$: Observable<Account[]>;
  confirmationNumber$: Observable<string>;

  constructor(
    private store: Store<StepIndicatorModel>,
  ) {
  }

  ngOnInit(): void {
    // this.currentStepIndicatorIndex$ = this.store.select((state:any) => (state.stepIndicatorReducer.currentStepIndex));
    this.currentStepIndicatorIndex$ = this.store.pipe(select(selectStepIndicatorIndex));
    this.confirmationNumber$ = this.store.pipe(select(selectConfirmationNumber));
    this.address$ = this.store.pipe(select(selectAddAddress));
    this.address$.pipe().subscribe(() => {
      // console.log(data)
    });
    this.allAccounts$ = this.store.pipe(select(selectSendAccounts));
    this.allAccounts$.pipe().subscribe((data: any) => {
      // console.log(data.accounts)
      this.accounts = JSON.parse(JSON.stringify(data.accounts));
      this.accounts = this.accounts.filter(account => {
        if (account.productType.includes('BROKERAGE') && account.isChecked === true) {
          return account;
        } else {
          account.positions = account.positions.filter(pos => {
            if (pos.isChecked === true) return pos;
          });
          if (account.positions.length > 0) return account;
        }
      });
      // console.log(this.accounts)
    });
    this.getAemContent();
    window.scrollTo({ top: 0, behavior: 'smooth' });

  }

  private getAemContent(): void {
    this.confirmPageDetails = AemUtil.getConfirmationPageDetails(this.thirdpartyDocumentsAemContent);
    this.labels.heading = this.confirmPageDetails.heading;
    this.labels.confirmationNumberHeading = this.confirmPageDetails.additionalHeading;
    this.labels.thankYouMessage = this.confirmPageDetails.bodyHtml;
    const selectionPageFields = AemUtil.getTableColumnLabels(this.thirdpartyDocumentsAemContent, ACCOUNTS_AVAILABLE_FOR_SELECTION_TABLE);
    this.labels.symbol = selectionPageFields.symbol;
    this.labels.name = selectionPageFields.name;
    this.labels.fundAccount = selectionPageFields.fundAccount;
    this.labels.duplicateStatementAddress = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, DUPLICATE_STATEMENT_ADDRESS_LABEL);
    this.labels.selectedAccounts = AemUtil.getSelectedAccountLable(this.thirdpartyDocumentsAemContent, REVIEW_AND_SUBMIT_PAGE_CONTAINER);
    this.labels.backToDuplicateStatements = AemUtil.getPrimaryCtaLabel(this.thirdpartyDocumentsAemContent, BACK_TO_DUPLICATE_STATEMENTS_BUTTON);
    this.labels.showMore = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, SHOW_MORE_LABEL);
    this.labels.showLess = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, SHOW_LESS_LABEL);
    this.labels.selectAccountTableLabel = AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, SELECT_ACCOUNT_TABLE_LABEL);
  }

  handleClick = (event: any) => {
    const expandedState = event.currentTarget.getAttribute('aria-expanded') === 'true';
    event.currentTarget.setAttribute('title', expandedState ? this.labels.showMore : this.labels.showLess);
    event.currentTarget.setAttribute('aria-expanded', !expandedState);
    if (!expandedState) {
      event.currentTarget.parentElement.parentElement.classList.add('c11n-accordion--expanded');
    } else {
      event.currentTarget.parentElement.parentElement.classList.remove('c11n-accordion--expanded');
    }
  };
}
